const Cloud = [
    {
      id: 1,
      name: "Sanket Patil",
      position: "Cloud Lead",
      image: "https://i.ibb.co/1MPtsfP/Sanket-Patil.jpg",
      alt: "Lead_Image",
      col: 6,
      linkedin: "https://www.linkedin.com/in/sanket-p27/",
      instagram: "",
      github: "",
      googleCloud: "",
      link: "",
    },
  ];
  
  export default Cloud;
  